import logo from '../../assets/img/logo.png';
import iconPengumuman from '../../assets/img/icon_pengumuman.png';
import './style.css';

export default function Header() {
  return (
    <div className="topbar">
      <header className="header">
        <div className="container header-inner">
          <img src={logo} alt="Logo Kemenag" className="header-logo" />
          <div className="header-text">
            <h1 className="header-title">
              PMBM JPPT (Penerimaan Murid Baru Madrasah Jalur Pendaftaran Tahfidz Terpadu)
            </h1>
            <p className="header-subtitle">Kanwil Kementerian Agama DIY</p>
          </div>
        </div>
      </header>

      <div className="announcement-bar">
        <div className="container announcement-inner">
          <img src={iconPengumuman} alt="Pengumuman" className="announcement-icon" />
          <div className="announcement-track">
            <span className="announcement-text">
              📢 Pengumuman: Seleksi Penerimaan Murid Baru Madrasah Jenjang MI, MTs, dan MA Jalur Pendaftaran Tahfidz Terpadu Tahun 2026 akan di buka 3 Maret 2026 pukul 08:00 WIB - 5 Maret 2026 pukul 15:00 WIB
            </span>
          </div>
        </div>
      </div>
    </div>
  );
}